export const en_us = {
    message: {
        common: {
            collaborators: 'Team members',
            my_profile: 'My Profile',
            user: 'User',
            password: 'Password',
            confirm: 'Confirm',
            back: 'Back',
            filters: 'Filters',
            filters_text: 'Filters referring to',
            adm: 'Administrator',
            master: 'Administrator Master',
            bdm: 'BDM',
            eng: 'Engineer',
            managers: 'Manager',
            inside: "Inside",
            seller: "Seller",
            adm_brand: 'Brand administrators',
            intermediary: 'Intermediary',
            sellers: "Sellers",
            clear: 'Clear',
            apply: 'Apply',
            brands: 'Brands',
            resales: 'Business Partners',
            goals: 'Goals',
            yes: 'Yes',
            atention: 'Attention',
            session_expired_message: 'Your session has expired, please log in again.',
            exit_message: 'Are you sure you want to exit?',
            version: 'Version',
            profile: 'Change profile photo',
            rights_reserved: 'Aurora, all rights reserved.',
            from: 'From:',
            to: 'To:',
            from_elipssis: 'From...',
            to_elipssis: 'To...',
            future_commission: 'Future Commission',
            goal_name: 'Name of the goal',
            goal_name_elipssis: 'Name of the goal...',
            role: 'Role',
            role_elipssis: 'Role...',
            orientation: 'Orientation',
            margin: 'Margin',
            range: 'Range',
            period: 'Period',
            commission: 'Commission',
            name: 'Name',
            name_elipssis: 'Name...',
            performer: 'Performance',
            performer_elipssis: 'Performance...',
            title: 'Goal title',
            goal_orientation: 'Goal orientation',
            brand: 'Brand',
            warehouse: 'Warehouse',
            cost_center: 'Cost Center',
            triggers: 'Triggers',
            seasonality: 'Seasonality',
            Seasonalities: 'Seasonalities',
            required: 'Required',
            required_field: 'Required field',
            cross: 'Cross',
            transfer: 'Transfer',
            sale_goal: 'Clearence',
            no_information: 'No information to display',
            success: 'Success!',
            status: 'Status',
            export: 'Export',
            invoice: 'Invoice',
            billing_date: 'Billing Date',
            total_sales: 'Total Sales',
            type_note: 'Type',
            line: 'Line',
            quantity: 'Quantity',
            commissioning: 'Commissioning',
            part_number: 'Part Number',
            installment: 'Installment',
            installments: 'Installments',
            duedate: 'Due Date',
            display: 'Display',
            hide: 'To hide',
            select: 'Select',
            sap_code: 'SAP Code',
            options: 'Options',
            search: 'Search in table...',
            edit: 'Edit',
            deactivate: 'Deactivate',
            type_confirm: 'Type “YES” to confirm',
            continue: 'Continue',
            no: 'No',
            description: 'Description',
            goal_not_found: 'Goal not found',
            brand_not_found: 'Brand not found',
            partner_not_found: 'Business Partner not found',
            warehouse_not_found: 'Warehouse not found',
            goal_create_fail: 'Error creating goal',
            goal_create_success: 'Goal created successfully',
            goal_update_success: 'Goal successfully updated',
            goal_update_fail: 'Error updating meta',
            not_allowed: 'Not allowed',
            not_defined: 'Not defined',
            portuguese: 'Portuguese',
            english: 'English',
            spanish: 'Spanish',
            sellerName: "Seller's name",
            register: 'Register ',
            update: 'Update ',
            data_updated: 'Your data has been updated successfully',
            unexpected_error: 'An unexpected system error has occurred, please contact support',
            select_collaborator: 'Select the collaborator',
            word_validation: 'You must enter the word to continue!',
            word_validation_error: 'The entered word is different from the requested word!',
            created_text: 'created successfully!',
            updated_text: 'has been updated successfully!',
            deactivated_text: 'successfully deactivated!',
            select_hiring: 'Select the user hiring model!',
            wrong_credentials: 'Incorrect username or password information',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
            locale: 'enUS',
            to_locale: 'from',
            to_date: 'of',
            date_connection: 'to',
            current_month: 'Current month',
            last_month: 'Last month',
            home_description_image: '/description_eng.png',
            web_title: `Sales Commission`,
            information: 'The information on this portal is updated daily during the night, in addition, invoices are added to the portal two days after they are invoiced.',
            invoiced_status: 'invoiced',
            employee_role: 'Employee role',
        },
        login: {
            welcome: 'Welcome!',
            form_user: 'Fill in the fields below correctly to access the platform',
            user_computer: 'Computer user',
            enter: 'To enter',
            policy: 'Privacy Policy',
            policy_document_link: '/documents/Política_de_Privacidade.pdf',
            new_way: 'A new way to view your sales information',
            query: 'Consult data regarding your goals, sales and commissions quickly and easily',
            cookies: 'To offer the best possible experience on our website, we use cookies. By continuing to browse, you agree to the use of these cookies. They are essential to guarantee features such as secure login. Find out more in our Privacy Policy',
            agree: 'I agree',
        },
        home: {
            greeting: 'Welcome to the Sales Commission Portal',
            values: ' values',
            search_for_collaborator: 'Search collaborator',
            filter_functions: 'Role Filter',
            select_function: 'Select the desired role',
            commission: 'Commission receivable',
            progress_goals: 'Goal progress for the current month',
            more_details: 'See more details',
            showing: 'Showing',
            results: 'of {number} results',
        },
        goals: {
            filter_goals: 'Filter goals by',
            export: 'Export goals',
            register: 'Register new goal',
            date_filter: 'Date filter',
            select: 'Select the desired month/year or period',
            closed: 'Closed goals',
            goal_found: 'No goal found',
        },
        goals_create: {
            employee_information: 'Employee information',
            information_goal: 'The following information is valid for the goal group',
            employee: 'Employee',
            goal_registration: 'Goal registration',
            fill_field: 'Fill in this field for goal title...',
            resale: 'Business Partner',
            choose_brand: 'Choose the brand',
            choose_cost_center: 'Choose the cost centers',
            choose_resale: 'Choose the business partner',
            choose_deposits: 'Choose the warehouses',
            period: 'Period definition',
            from_goals: 'From',
            to_goals: 'To',
            optional: 'Optional settings',
            add_goal: 'Add goal',
            action: 'Action',
            complete_registration: 'Complete registration',
            goals_created: 'Goals were successfully created!',
            ok: 'OK',
            goal_updated: 'Goal successfully changed',
        },
        goals_details: {
            details: 'Goal details',
            employee_name: 'Employee name',
            active: 'Active',
            inactive: 'Inactive',
            inactive_goal: 'INACTIVE GOAL',
            reason: 'Reason',
            search_brand: 'Search brands...',
            search_resale: 'Search business partners...',
            search_warehouse: 'Search warehouses...',
            search_cost_centers: 'Search cost centers...',
            change_goal: 'Change',
            save: 'Save',
            jan: 'Jan',
            feb: 'Feb',
            mar: 'Mar',
            apr: 'Apr',
            may: 'May',
            jun: 'Jun',
            jul: 'Jul',
            aug: 'Aug',
            sep: 'Sep',
            oct: 'Oct',
            nov: 'Nov',
            dec: 'Dec',
            not_applicable: 'Not applicable',
            close_goal: 'Close goal',
            brands_add: 'Brands to be added',
            choose_brands: 'Choose brands to add',
            cost_centers: 'Cost Centers',
            cost_center_to_add: 'Cost Center(s) to be added',
            choose_cost_centers_to_add: 'Choose the Cost Center(s) to add',
        },
        goals_delete: {
            close_goal: 'Do you want to close the goal?',
            reason: 'Enter the reason for closing',
            goal_closed: 'Goal successfully closed',
            delete_text: 'Do you really want to delete the goal',
            delete_period: 'Period of',
            to: 'until',
        },
        invoices: {
            notes: 'Notes',
            filter_notes: 'Filter notes by',
            note_filter: 'Note filter',
            select_date: 'Select “From” and “To” dates',
            refine_notes: 'Refine your search by notes below',
            note_number: 'Note number:',
            note: 'Note...',
            customer_name: 'Customer name:',
            customer: 'Customer...',
            resale_name: 'Name of the business partner:',
            resale_name_: 'Name of the business partner',
            resale_notes: 'Business Partner...',
        },
        billing_notes: {
            billing_notes: 'Invoice Notes',
            receiving_notes: 'Receiving Notes',
            resale_code: 'Partner Code',
            resale_name_note: 'Partner Name',
            customer_code: 'Customer Code',
            customer_name_code: 'Customer Name',
            total_resale: 'Total BP',
            base_note: 'Base',
            display_commissions: 'Display commissions',
            category: 'Category',
        },
        receipt_notes: {
            installments: 'Installments',
            receiptDate: 'Receipt Date',
            totalmargin: 'Total Margin',
            installmentmargin: 'Installment Margin',
        },
        reports: {
            reports: 'Reports',
            report_type: 'Select report type',
            select_month: 'Select the month',
            report_title_monthly_available: 'Monthly Commission Available',
            report_title_provision: 'Provision Commission (Conference)',
            report_title_summary: 'Billing Summary of the Month',
            report_title_individual: 'Individual Commission',
            report_title_available_goal: 'Commissions Available by Goal',
            report_title_future: 'Future Commissions',
            report_title_billing: 'Billing Notes',
            report_title_receipt: 'Receipt Notes',
            report_title_cost_center: 'Totalization by Cost Center',
            report_title_dre: 'DRE per Employee',
            report_description_monthly_available: "Report containing the sum of revenue and the sum of commissions available in the employee's month",
            report_description_provision: "Report containing revenue and commissions available for the month, separated by employee goal",
            report_description_summary: "Report containing the \"Billing Summary of the Month\" as seen in the employee's profile",
            report_description_individual: "Report containing the \"Available Commissions\" as seen in the employee's profile",
            report_description_available_goal: "Report containing the \"Available Commissions\" for the month separated by employee goal",
            report_description_future: "Report containing \"Future Commissions\" as seen in the employee's profile",
            report_description_billing: "Report containing the invoices billed in the period sought",
            report_description_receipt: "Report containing notes received in the period sought",
            report_description_cost_center: "Report containing the month's billing separated by \"Cost Center\"",
            report_description_dre: "Report containing the income statement for the selected month for the selected employee",
        },
        brands_create: {
            brand_registration: 'Brand Registration',
            brands_name: 'Brand Name',
            sap_identifier: 'SAP Brand Identifier',
            brand_logo: 'Brand Logo',
            file_name: 'File name...',
            upload_image: 'Upload Image',
            register_brand: 'Register brand',
            update_brand: 'Update brand',
        },
        brands_table: {
            brand_table: 'Brand Name',
        },
        brands_delete: {
            deactivate_brand: 'Do you really want to deactivate the brand',
        },
        warehouse_create: {
            warehouses: 'Warehouses',
            warehouse_title: 'Name of the warehouse',
            warehouse_registration: 'Warehouse registration',
            warehouse_name: 'Name corresponding to the warehouse',
            sap_identifier_warehouse: 'Warehouse identifier in SAP',
            warehouse_base: 'Warehouse Base',
            warehouse_created: 'Warehouse created successfully!',
        },
        warehouse_table: {
            search_deposit: 'Search in table',
        },
        warehouse_delete: {
            confirm_dactivate_warehouse: 'Do you really want to deactivate the warehouse',
        },
        resale_delete: {
            confirm_dactivate_resale: 'Do you really want to deactivate the business partner',
        },
        resale_create: {
            title: 'Registration of the Business Partner',
            cnpj: 'CNPJ of the Business Partner',
            placeholder_code: 'Identifier of the Partner',
            value: 'Value',
            resale_code: 'Partner Code',
        },
        contributor_summary: {
            value_month: 'Values ​​referring to {value}',
            revenue_margin: 'Revenue Margin',
            total_revenue: 'Total Revenue',
            commission_available: 'Commission Available',
            progress_in_the_month: 'Goal progress for the month',
            active_goals: 'Active Goals',
            dont_apply: '- filters do not apply here',
            all_goals: 'See all goals',
            summary_margin: 'Summary of margin in the month',
            progress: 'Progress',
            color: 'Color',
            trigger: 'Trigger',
            blue_message: 'Goal in progress',
            green_message: 'Goal achieved and counts performance',
            grey_message: 'Goal does not count performance',
            available_commissions: 'Available Commissions',
            future_commissions: 'Future Commissions',
            annual_billing: 'Annual Billing',
            annual_goal: 'Annual Goal',
            goal_group: 'Goal Group',
            annual_margin: 'Annual Margin',
        },
        results: {
            customer: 'customer',
            number_installments: 'Number of installments',
            invoicing_number: 'Date Invoicing',
            receipt_date: 'date of receipt',
            total_margin: 'Total margin',
            installment_margin: 'Installment margin',
            goal: 'Goal',
        },
        future_commisions: {
            line_red: 'Red lines indicate invoices with financial issues',
        },
        settings: {
            settings: 'Settings',
            users: 'Users',
            available_users: 'Available users',
            register: 'Register',
            registration_SAP: 'Registration in SAP',
            code: 'Code',
            permission: 'Permission',
            master: 'Master administrator',
            hiring_model: 'Hiring model',
            new_user: 'Create new',
            select_user: 'Select an available user in the table to the side to register on the platform.',
            search_table: 'Table search',
            user_name: 'Username',
            permissions: 'Permissions',
            action_inactivate: 'Do you really want to deactivate the user',
        },
        role: {
            function_title: 'Roles',
            registration_function_title: 'Role Registration',
            name_function: 'Name of the Role',
            description_function: 'Role Description',
            register_function: 'Register Role',
            ok: 'ok',
            action_inactivate_role: 'Do you really want to disable the role',
        },
        seasoning: {
            register_seasonality_title: 'Seasonality Registration',
            seasonality_title: 'Seasonality name',
            name_seasonality: 'Name corresponding to seasonality',
            description_seasonality: 'Description corresponding to seasonality',
            start_date: 'Start date',
            end_date: 'End date',
            type_seasonality: 'Select the type of seasonality you will register',
            monthly: 'Monthly',
            quarter: 'Quarter',
            value: 'Value',
            register_seasonality: 'Attention The sum of the seasonality weights must be 100%',
            action_inactivate_seasonality: 'Do you really want to disable seasonality',
            value_percent: 'Value %',
            first_quarter: 'Q1',
            second_quarter: 'Q2',
            third_quarter: 'Q3',
            fourth_quarter: 'Q4',
            select_type: 'Select the type of seasonality',
        },
        triggers: {
            trigger_title: 'Trigger Registration',
            trigger_name_table: 'Trigger Name',
            trigger_name: 'Name corresponding to the trigger',
            interval_value: 'Range value',
            final_value: 'Final value',
            add_range: 'Add Range',
            delete_last_range: 'Delete last range',
            interval: 'Interval',
            warning_trigger: 'The sum of the trigger items must be 100%',
            bonus: 'Bonus',
            bonus_above_one_hundred: 'Enter the bonus percentage',
            action_inactivate_triggers: 'Do you really want to disable the trigger',
            triger_item_value_not_defined: 'Trigger value not defined',
            order_modal: 'Order',
            initial_value_modal: 'Initial Value of the Range',
            final_value_modal: 'Final Value of the Range',
        },
        messages: {
            goal_required_field_missing: 'Mandatory field in meta not filled',
            trigger_item_not_found: 'Trigger item not found',
            triger_item_value_not_defined: 'Trigger item value not defined',
            clearance_sale_reward_not_defined: 'Saldão reward not defined',
            triger_item_not_defined: 'Trigger item not defined',
            reason_required: 'Mandatory to fill in the reason field',
            brands_required: 'Brand field is required',
            goal_already_exists: 'Goal is already registered',
            brand_already_registered: 'Brand is registered',
            result_not_found: 'Unexpected result',
        },
        validations: {
            invalid_credentials: 'Invalid Credentials',
            brand_create_success: 'Brand successfully created',
            brand_create_fail: 'Error creating brand',
            brand_update_success: 'Brand successfully updated',
            brand_update_fail: 'Error updating brand',
            brand_delete_success: 'Brand successfully deleted',
            brand_delete_fail: 'Error deleting brand',
            missing_required_fields: 'Mandatory fields not filled in',
            configuration_not_found: 'Configuration not found',
            configuration_create_success: 'Configuration created successfully',
            configuration_create_fail: 'Error registering configuration',
            configuration_update_success: 'Configuration updated successfully',
            configuration_update_fail: 'Error updating configuration',
            start_date_greater_than_end_date: 'Start date greater than end date',
            error_consulting_database: 'Error querying database',
            goal_required_field_missing: 'Required fields not filled in for the goal',
            trigger_item_not_found: 'Trigger Item Not Found',
            triger_item_value_not_defined: 'Trigger Item Value not defined',
            clearance_sale_reward_not_defined: 'Sale reward value not defined',
            reason_required: 'Reason is required',
            users_ids_null: 'User must not be null or undefined',
            roles_ids_null: 'Role must not be null or undefined',
            seasons_ids_null: 'Seasonality should not be null or undefined',
            performants_null: 'Performer must not be null or undefined',
            goal_liness_null: 'Goal Lines must not be null or undefined',
            goal_user_not_found: 'Collaborator not found',
            goal_role_not_found: 'Role not found',
            goal_seller_not_found: 'Seller not found',
            goal_already_exists: 'Goal already exists',
            invoice_not_found: 'Invoice not found',
            item_not_found: 'Item not found',
            performant_not_found: 'Performer not found',
            preview_not_found: 'Preview not found',
            provision_not_found: 'Provision not found',
            reception_not_found: 'Receipt not found',
            resale_create_success: 'Business Partner successfully created',
            resale_create_fail: 'Error creating business partner',
            resale_update_success: 'Business partner successfully updated',
            resale_update_fail: 'Error updating business partner',
            resale_delete_fail: 'Error deleting business partner',
            resale_delete_success: 'Business partner successfully deleted',
            role_not_found: 'Role not found',
            role_create_success: 'Role created successfully',
            role_create_fail: 'Error creating role',
            role_update_success: 'Role updated successfully',
            role_update_fail: 'Error updating role',
            role_delete_fail: 'Error deleting role',
            role_delete_success: 'Role deleted successfully',
            season_not_found: 'Seasonality not found',
            season_hundred_error: 'The sum of the seasonality weights must be 100%',
            season_create_success: 'Seasonality successfully created',
            season_create_fail: 'Error creating seasonality',
            season_delete_fail: 'Error deleting seasonality',
            season_delete_success: 'seasonality successfully deleted',
            trigger_not_found: 'Trigger not found',
            trigger_items_not_set: 'Trigger ranges not filled',
            trigger_item_value_error: 'Error passing value of trigger items',
            trigger_item_hundred_error: 'The sum of the trigger items must be 100%',
            trigger_item_create_fail: 'Error creating Trigger Items',
            trigger_create_success: 'Trigger created successfully',
            trigger_create_fail: 'Error creating trigger',
            trigger_item_delete_fail: 'Error deleting trigger item',
            trigger_delete_fail: 'Error deleting trigger',
            trigger_delete_success: 'Trigger successfully deleted',
            user_not_found: 'User not found',
            user_create_success: 'User created successfully',
            user_create_fail: 'Error creating user',
            user_update_success: 'User updated successfully',
            user_update_fail: 'Error updating user',
            user_delete_success: 'User successfully deleted',
            user_delete_fail: 'Error deleting user',
            preference_not_set: 'Preference not set',
            user_preference_success: 'Preference user not set',
            user_preference_fail: 'Error creating Preference User',
            warehouse_create_success: 'Warehouse created successfully',
            warehouse_create_fail: 'Error creating warehouse',
            warehouse_update_success: 'Warehouse updated successfully',
            warehouse_update_fail: 'Error updating warehouse',
            warehouse_delete_success: 'Warehouse deleted successfully',
            warehouse_delete_fail: 'Error deleting warehouse',
            unauthorized: 'Not authorized',
            InternalServer_Error: 'Oops..An unexpected system error has occurred, please contact support',
            only_image_allowed: 'Only image type files are allowed',
            resale_already_exists: 'Business partner already exists',
            sap_users_id: 'The "SAP Record" field cannot be empty',
            sap_card_code: 'The "Business Partner Code" field cannot be empty',
            sap_card_name: 'The "Name" field cannot be empty',
            sap_code: 'The "SAP Code" field cannot be empty',
            company: 'The "Warehouse Base" field cannot be empty',
            start_date: 'The "Start date" field cannot be empty',
            end_date: 'The "End date" field cannot be empty',
            jan: 'The "January" field cannot be empty',
            feb: 'The "February" field cannot be empty',
            mar: 'The "March" field cannot be empty',
            apr: 'The "April" field cannot be empty',
            may: 'The "May" field cannot be empty',
            jun: 'The "June" field cannot be empty',
            jul: 'The "July" field cannot be empty',
            aug: 'The "August" field cannot be empty',
            sep: 'The "September" field cannot be empty',
            oct: 'The "October" field cannot be empty',
            nov: 'The "November" field cannot be empty',
            dec: 'The "December" field cannot be empty',
            brands_required: 'Enter the brand to be added',
            brand_already_registered: 'Brand already registered in the goal',
            items_required: 'Item not provided',
            invoice_or_item_not_found: 'Item or Invoice not found',
            item_update_fail: 'Error updating the item',
            item_update_success: 'Item updated successfully',
        },
        breadcrumbs: {
            invoices: 'Notes',
            goals: 'Goals',
            reports: 'Reports',
            settings: 'Settings',
        },
        edit_invoice: {
            warning_message: 'No margin has been changed',
            verify_message: 'Are you sure you want to save the changes to the invoice margins?',
            success_message: 'Invoices successfully updated',
            customer_code: 'Customer code',
            customer_name: 'Customer name',
            item_total: 'Item Total',
            btn_title: 'Change the invoice margin',
            title_edit: 'Change the item margin value',
        },
        status: {
            invoiced: "Invoiced",
            cancelled: "Cancelled",
            returned: "Returned",
            return_cancelled: "Return Cancelled"
        },
        goals_group: {
            goal_group_created_successfully: 'Goal group created successfully!',
            create_group: 'Create group',
            create_new_group: 'Create new group',
            select_group: 'Select group',
            view_group_details: 'View group details',
        }
    },
};